import { gql } from "@apollo/client"

const GET_INVITATIONS_EMAIL_SELECTOR = gql`
  query invitationsEmailSelector($input: InvitationsEmailSelectorInput!, $page: Int!, $perPage: Int!) {
    invitationsEmailSelectorIds(input: $input) {
      id
      invitation_id
      user_id
    }

    invitationsEmailSelector(first: $perPage, page: $page, input: $input) {
      data {
        id
        guardian
        students
        email
        user_id
        booking_counts
        slot_counts
        activated_at
        status
        last_sent_at
      }
      
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
        hasMorePages
      }
    }
  }
`

export { GET_INVITATIONS_EMAIL_SELECTOR }
